module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.params && _vm.params.isActive) ? _c('div', [_c('ModalDefault', {
    attrs: {
      "size": "m",
      "with-content": true,
      "theme": true,
      "fix-height": false,
      "fix-width": false,
      "loading": _vm.loading
    },
    on: {
      "close": function($event) {
        _vm.close();
      }
    }
  }, [_c('template', {
    slot: "main"
  }, [_c('section', {
    staticClass: "delete-brand"
  }, [_c('p', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$trad.common.delete))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (
        _vm.$t('zonerole.deleteFromBrand', {
          zone: _vm.params.zone.name.toUpperCase(),
          brand: this.params.brandZone.brand.name.toUpperCase()
        })
      ),
      expression: "\n                        $t('zonerole.deleteFromBrand', {\n                            zone: params.zone.name.toUpperCase(),\n                            brand: this.params.brandZone.brand.name.toUpperCase()\n                        })\n                    "
    }]
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("deleteBrand.messageAction")))]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex justify-content-end"
  }, [_c('ClientColorButton', {
    staticClass: "mr-3",
    attrs: {
      "background-color": _vm.currentBrand.linksColor
    },
    on: {
      "click": function($event) {
        _vm.disableBrandZone();
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.delete))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "inactiveColor": true
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$trad.common.cancel))])], 1)])])], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbc7c318","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/zone/DisableBrandZone.vue
// module id = 3356
// module chunks = 0